import { createFileRoute } from "@tanstack/react-router";

import { canManageHelpCenter } from "@/core/lib/access";
import { denyRouteAccess } from "@/core/lib/route-access";

export const Route = createFileRoute("/_protected/help-center/articles/new")({
  beforeLoad: ({ context, ...guard }) => {
    if (!canManageHelpCenter(context.user)) {
      denyRouteAccess(guard, "help_center_manager");
    }
  },
  validateSearch: (search: Record<string, unknown>) => {
    return {
      templateId: (search.templateId as string) || undefined,
    };
  },
});
